import { render, staticRenderFns } from "./LookupListInput.vue?vue&type=template&id=32000800&scoped=true"
import script from "./LookupListInput.vue?vue&type=script&lang=js"
export * from "./LookupListInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32000800",
  null
  
)

export default component.exports